const words = {
  levelOne: {
    at: { phonics: ["a", "t"] },
    sit: { phonics: ["s", "i", "t"] },
    sat: { phonics: ["s", "a", "t"] },
    tap: { phonics: ["t", "a", "p"] },
    pit: { phonics: ["p", "i", "t"] },
    pat: { phonics: ["p", "a", "t"] },
    tip: { phonics: ["t", "i", "p"] },
    in: { phonics: ["i", "n"] },
    it: { phonics: ["i", "t"] },
    sip: { phonics: ["s", "i", "p"] },
    sap: { phonics: ["s", "a", "p"] },
    nap: { phonics: ["n", "a", "p"] },
    pan: { phonics: ["p", "a", "n"] },
    pin: { phonics: ["p", "i", "n"] },
    ant: { phonics: ["a", "n", "t"] },
    tin: { phonics: ["t", "i", "n"] },
    map: { phonics: ["m", "a", "p"] },
    mat: { phonics: ["m", "a", "t"] },
    mop: { phonics: ["m", "o", "p"] },
    mad: { phonics: ["m", "a", "d"] },
    sad: { phonics: ["s", "a", "d"] },
    dog: { phonics: ["d", "o", "g"] },
    dig: { phonics: ["d", "i", "g"] },
    did: { phonics: ["d", "i", "d"] },
    got: { phonics: ["g", "o", "t"] },
    tag: { phonics: ["t", "a", "g"] },
    pot: { phonics: ["p", "o", "t"] },
    cat: { phonics: ["c", "a", "t"] },
    kid: { phonics: ["k", "i", "d"] },
    kit: { phonics: ["k", "i", "t"] },
    pack: { phonics: ["p", "a", "ck"] },
    sock: { phonics: ["s", "o", "ck"] },
    sack: { phonics: ["s", "a", "ck"] },
    met: { phonics: ["m", "e", "t"] },
    peg: { phonics: ["p", "e", "g"] },
    ten: { phonics: ["t", "e", "n"] },
    men: { phonics: ["m", "e", "n"] },
    pup: { phonics: ["p", "u", "p"] },
    mud: { phonics: ["m", "u", "d"] },
    sun: { phonics: ["s", "u", "n"] },
    duck: { phonics: ["d", "u", "ck"] },
    up: { phonics: ["u", "p"] },
    mug: { phonics: ["m", "u", "g"] },
    ran: { phonics: ["r", "a", "n"] },
    rat: { phonics: ["r", "a", "t"] },
    run: { phonics: ["r", "u", "n"] },
    rock: { phonics: ["r", "o", "ck"] },
    hat: { phonics: ["h", "a", "t"] },
    hen: { phonics: ["h", "e", "n"] },
    hut: { phonics: ["h", "u", "t"] },
    hip: { phonics: ["h", "i", "p"] },
    bag: { phonics: ["b", "a", "g"] },
    bug: { phonics: ["b", "u", "g"] },
    bed: { phonics: ["b", "e", "d"] },
    bus: { phonics: ["b", "u", "s"] },
    fan: { phonics: ["f", "a", "n"] },
    fin: { phonics: ["f", "i", "n"] },
    cuff: { phonics: ["c", "u", "ff"] },
    off: { phonics: ["o", "ff"] },
    lock: { phonics: ["l", "o", "ck"] },
    lips: { phonics: ["l", "i", "p", "s"] },
    log: { phonics: ["l", "o", "g"] },
    leg: { phonics: ["l", "e", "g"] },
    fell: { phonics: ["f", "e", "ll"] },
    hill: { phonics: ["h", "i", "ll"] },
    doll: { phonics: ["d", "o", "ll"] },
    gull: { phonics: ["g", "u", "ll"] },
    bell: { phonics: ["b", "e", "ll"] },
    sell: { phonics: ["s", "e", "ll"] },
    mess: { phonics: ["m", "e", "ss"] },
    hiss: { phonics: ["h", "i", "ss"] },
    dress: { phonics: ["d", "r", "e", "ss"] },
    glass: { phonics: ["g", "l", "a", "ss"] },
    grass: { phonics: ["g", "r", "a", "ss"] },
    class: { phonics: ["c", "l", "a", "ss"] },
  },
  levelTwo: {
    jog: { phonics: ["j", "o", "g"] },
    jet: { phonics: ["j", "e", "t"] },
    jam: { phonics: ["j", "a", "m"] },
    jug: { phonics: ["j", "u", "g"] },
    vest: { phonics: ["v", "e", "s", "t"] },
    vet: { phonics: ["v", "e", "t"] },
    van: { phonics: ["v", "a", "n"] },
    wag: { phonics: ["w", "a", "g"] },
    wet: { phonics: ["w", "e", "t"] },
    win: { phonics: ["w", "i", "n"] },
    web: { phonics: ["w", "e", "b"] },
    fox: { phonics: ["f", "o", "x"] },
    box: { phonics: ["b", "o", "x"] },
    mix: { phonics: ["m", "i", "x"] },
    yap: { phonics: ["y", "a", "p"] },
    yell: { phonics: ["y", "e", "ll"] },
    zip: { phonics: ["z", "i", "p"] },
    zebra: { phonics: ["z", "e", "b", "r", "a"] },
    buzz: { phonics: ["b", "u", "zz"] },
    fizz: { phonics: ["f", "i", "zz"] },
    quack: { phonics: ["qu", "a", "ck"] },
    quilt: { phonics: ["qu", "i", "l", "t"] },
    squid: { phonics: ["s", "qu", "i", "d"] },
    chin: { phonics: ["ch", "i", "n"] },
    chop: { phonics: ["ch", "o", "p"] },
    chips: { phonics: ["ch", "i", "p", "s"] },
    chest: { phonics: ["ch", "e", "s", "t"] },
    shell: { phonics: ["sh", "e", "ll"] },
    fish: { phonics: ["f", "i", "sh"] },
    ship: { phonics: ["sh", "i", "p"] },
    shed: { phonics: ["sh", "e", "d"] },
    rush: { phonics: ["r", "u", "sh"] },
    path: { phonics: ["p", "a", "th"] },
    bath: { phonics: ["b", "a", "th"] },
    moth: { phonics: ["m", "o", "th"] },
    sing: { phonics: ["s", "i", "ng"] },
    wing: { phonics: ["w", "i", "ng"] },
    ring: { phonics: ["r", "i", "ng"] },
    king: { phonics: ["k", "i", "ng"] },
    rain: { phonics: ["r", "ai", "n"] },
    tail: { phonics: ["t", "ai", "l"] },
    sail: { phonics: ["s", "ai", "l"] },
    train: { phonics: ["t", "r", "ai", "n"] },
    sheep: { phonics: ["sh", "ee", "p"] },
    jeep: { phonics: ["j", "ee", "p"] },
    tree: { phonics: ["t", "r", "ee"] },
    light: { phonics: ["l", "igh", "t"] },
    high: { phonics: ["h", "igh"] },
    toad: { phonics: ["t", "oa", "d"] },
    loaf: { phonics: ["l", "oa", "f"] },
    goat: { phonics: ["g", "oa", "t"] },
    coat: { phonics: ["c", "oa", "t"] },
    book: { phonics: ["b", "oo", "k"] },
    foot: { phonics: ["f", "oo", "t"] },
    look: { phonics: ["l", "oo", "k"] },
    hook: { phonics: ["h", "oo", "k"] },
    moon: { phonics: ["m", "oo", "n"] },
    hoof: { phonics: ["h", "oo", "f"] },
    roof: { phonics: ["r", "oo", "f"] },
    boots: { phonics: ["b", "oo", "t", "s"] },
    jar: { phonics: ["j", "ar"] },
    shark: { phonics: ["sh", "ar", "k"] },
    card: { phonics: ["c", "ar", "d"] },
    car: { phonics: ["c", "ar"] },
    corn: { phonics: ["c", "or", "n"] },
    thorn: { phonics: ["th", "or", "n"] },
    torch: { phonics: ["t", "or", "ch"] },
    fork: { phonics: ["f", "or", "k"] },
    burst: { phonics: ["b", "ur", "s", "t"] },
    fur: { phonics: ["f", "ur"] },
    curls: { phonics: ["c", "ur", "l", "s"] },
    surf: { phonics: ["s", "ur", "f"] },
    owl: { phonics: ["ow", "l"] },
    crown: { phonics: ["c", "r", "ow", "n"] },
    cow: { phonics: ["c", "o", "w"] },
    gown: { phonics: ["g", "ow", "n"] },
    coin: { phonics: ["c", "oi", "n"] },
    oil: { phonics: ["oi", "l"] },
    poison: { phonics: ["p", "oi", "s", "o", "n"] },
    point: { phonics: ["p", "oi", "n", "t"] },
    beard: { phonics: ["b", "ear", "d"] },
    hear: { phonics: ["h", "ear"] },
    dear: { phonics: ["d", "ear"] },
    clear: { phonics: ["c", "l", "ear"] },
    chair: { phonics: ["ch", "air"] },
    pair: { phonics: ["p", "air"] },
    stairs: { phonics: ["s", "t", "air", "s"] },
    hair: { phonics: ["h", "air"] },
    manure: { phonics: ["m", "a", "n", "ure"] },
    mature: { phonics: ["m", "a", "t", "ure"] },
    secure: { phonics: ["s", "e", "c", "ure"] },
    cure: { phonics: ["c", "ure"] },
    hammer: { phonics: ["h", "a", "m", "m", "er"] },
    spanner: { phonics: ["s", "p", "a", "n", "n", "er"] },
    letter: { phonics: ["l", "e", "t", "t", "er"] },
    ladder: { phonics: ["l", "a", "d", "d", "er"] },
  },
  levelThree: {
    crayon: { phonics: ["c", "r", "ay", "o", "n"] },
    play: { phonics: ["p", "l", "ay"] },
    tray: { phonics: ["t", "r", "ay"] },
    rays: { phonics: ["r", "ay", "s"] },
    came: { phonics: ["c", "a", "m", "(e)"] },
    take: { phonics: ["t", "a", "k", "(e)"] },
    made: { phonics: ["m", "a", "d", "(e)"] },
    gate: { phonics: ["g", "a", "t", "(e)"] },
    herb: { phonics: ["h", "er", "b"] },
    expert: { phonics: ["e", "x", "p", "er", "t"] },
    perch: { phonics: ["p", "er", "ch"] },
    person: { phonics: ["p", "er", "s", "o", "n"] },
    bird: { phonics: ["b", "ir", "d"] },
    first: { phonics: ["f", "ir", "s", "t"] },
    twirl: { phonics: ["t", "w", "ir", "l"] },
    girl: { phonics: ["g", "ir", "l"] },
    theme: { phonics: ["th", "e", "m", "(e)"] },
    even: { phonics: ["e", "v", "e", "n"] },
    complete: {
      phonics: ["c", "o", "m", "p", "l", "e", "t", "(e)"],
    },
    extreme: { phonics: ["e", "x", "t", "r", "e", "m", "(e)"] },
    beast: { phonics: ["b", "ea", "s", "t"] },
    feast: { phonics: ["f", "ea", "s", "t"] },
    dream: { phonics: ["d", "r", "ea", "m"] },
    teach: { phonics: ["t", "ea", "ch"] },
    donkey: { phonics: ["d", "o", "n", "k", "ey"] },
    hockey: { phonics: ["h", "o", "ck", "ey"] },
    valley: { phonics: ["v", "a", "ll", "ey"] },
    alley: { phonics: ["a", "ll", "ey"] },
    cloud: { phonics: ["c", "l", "ou", "d"] },
    sound: { phonics: ["s", "ou", "n", "d"] },
    found: { phonics: ["f", "ou", "n", "d"] },
    loud: { phonics: ["l", "ou", "d"] },
    shine: { phonics: ["sh", "i", "n", "(e)"] },
    invite: { phonics: ["i", "n", "v", "i", "t", "(e)"] },
    prize: { phonics: ["p", "r", "i", "z", "(e)"] },
    time: { phonics: ["t", "i", "m", "(e)"] },
    pie: { phonics: ["p", "ie"] },
    dried: { phonics: ["d", "r", "ie", "d"] },
    lied: { phonics: ["l", "ie", "d"] },
    tie: { phonics: ["t", "ie"] },
    boy: { phonics: ["b", "oy"] },
    annoy: { phonics: ["a", "n", "n", "oy"] },
    enjoy: { phonics: ["e", "n", "j", "oy"] },
    toy: { phonics: ["t", "oy"] },
    launch: { phonics: ["l", "au", "n", "ch"] },
    jaunt: { phonics: ["j", "au", "n", "t"] },
    lawn: { phonics: ["l", "aw", "n"] },
    saw: { phonics: ["s", "aw"] },
    home: { phonics: ["h", "o", "m", "(e)"] },
    note: { phonics: ["n", "o", "t", "(e)"] },
    drone: { phonics: ["d", "r", "o", "n", "e"] },
    rope: { phonics: ["r", "o", "p", "e"] },
    grow: { phonics: ["g", "r", "ow"] },
    snow: { phonics: ["s", "n", "ow"] },
    glow: { phonics: ["g", "l", "ow"] },
    blow: { phonics: ["b", "l", "ow"] },
    toe: { phonics: ["t", "oe"] },
    woe: { phonics: ["w", "oe"] },
    doe: { phonics: ["d", "oe"] },
    foe: { phonics: ["f", "oe"] },
    when: { phonics: ["wh", "e", "n"] },
    which: { phonics: ["wh", "i", "ch"] },
    whisk: { phonics: ["wh", "i", "s", "k"] },
    wheel: { phonics: ["wh", "ee", "l"] },
    cube: { phonics: ["c", "u", "b", "(e)"] },
    use: { phonics: ["u", "s", "(e)"] },
    amused: { phonics: ["a", "m", "u", "s", "(e)", "d"] },
    flute: { phonics: ["f", "l", "u", "t", "(e)"] },
    cue: { phonics: ["c", "ue"] },
    argue: { phonics: ["ar", "g", "ue"] },
    venue: { phonics: ["v", "e", "n", "ue"] },
    rescue: { phonics: ["r", "e", "s", "c", "ue"] },
    new: { phonics: ["n", "ew"] },
    nephew: { phonics: ["n", "e", "ph", "ew"] },
    few: { phonics: ["f", "ew"] },
    blew: { phonics: ["b", "l", "ew"] },
    graph: { phonics: ["g", "r", "a", "ph"] },
    phonics: { phonics: ["ph", "o", "n", "i", "c", "s"] },
    graphics: {
      phonics: ["g", "r", "a", "ph", "i", "c", "s"],
    },
    phantom: { phonics: ["ph", "a", "n", "t", "o", "m"] },
  },
};

export default words;
